import { Modal, Input, Button } from 'antd';
import { useState } from 'react';
import { toast } from 'react-toastify';

interface ModalDeleteMassiveStaffProps {
    isOpen: boolean;
    setOpen: (isOpen: boolean) => void;
    operation: () => Promise<void>;
    itemsCount: number;
}

export function ModalDeleteMassiveStaff({
    isOpen,
    setOpen,
    operation,
    itemsCount
}: ModalDeleteMassiveStaffProps) {
    const [confirmText, setConfirmText] = useState('');

    const handleConfirm = async () => {
        if (confirmText.toLowerCase() === 'sim') {
            await operation();
            handleClose();
        } else {
            toast.error('Texto de confirmação inválido!');
        }
    };

    const handleClose = () => {
        setConfirmText('');
        setOpen(false);
    };

    return (
        <Modal
            title={`Tem certeza que deseja excluir ${itemsCount} funcionário(s)?`}
            open={isOpen}
            onCancel={handleClose}
            footer={[
                <Button key="back" onClick={handleClose}>
                    Cancelar
                </Button>,
                <Button key="submit" type="primary" danger disabled={confirmText.toLowerCase() !== 'sim'} onClick={handleConfirm}>
                    Confirmar Exclusão
                </Button>,
            ]}
        >
            <p>Para confirmar a exclusão de <strong>{itemsCount} funcionário(s)</strong>, digite "<strong>Sim</strong>"</p>
            <Input placeholder='Digite "sim" para confirmar' value={confirmText} onChange={(e) => setConfirmText(e.target.value)} />
        </Modal>
    );
}
